export const getListingPath = ({ path, domain }: { path: string; domain?: string }): string => {
  const prefix = domain ? `https://${domain}` : ''
  return `${prefix}${path}`
}

export const makeAbsoluteUrl = (url: string) => {
  if (typeof url !== 'string') {
    return null
  }

  return url.startsWith('/') ? url : `/${url}`
}
